import React, { useState, useEffect } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ActivityForm from '../../../components/forms/ActivityForm';
import { useActivityApi } from '../../../hooks/useActivityApi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ActivityDTO } from '../../../services/apiClient';

const ActivityCreate: React.FC = () => {
  const { create, isLoading } = useActivityApi();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<ActivityDTO>({} as ActivityDTO);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);

  useEffect(() => {
    const firearmId = searchParams.get('firearm');
    if (firearmId) {
      setInitialValues({ memberFirearmId: firearmId } as ActivityDTO);
    }
    setIsInitialized(true);
  }, [searchParams]);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Activities', href: '/admin/activities' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ActivityDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate(-1);
    } catch (error) {
      console.error('Error creating Activity:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/activities"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin', 'User']}
      requiredPermission='Manage.Activity.Edit'
    >
      {isInitialized && (
        <ActivityForm
          initialValues={initialValues}
          onSubmit={handleSubmit}
          onCancel={() => navigate(-1)}
          isLoading={isSubmitting}
        />
      )}
    </AdminLayout>
  );
};

export default ActivityCreate;